import { einIsValid } from "../../../../logic/RegexValidation";
import { ORGANIZATION_NAME_MAX_LENGTH } from "../../../../logic/ValidationChecks/FieldLengths";
import { getFieldRequiredValidationCheck, getMaxLengthValidationCheck, getStringErrors, getValidationErrorDictionary, getValidationErrors } from "../../../../logic/ValidationChecks/Validation";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { MainOrganizationDetailsStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

const validationChecks: (stepValues: MainOrganizationDetailsStepValues) => ValidationCheck<MainOrganizationDetailsStepValues>[] =
    (stepValues: MainOrganizationDetailsStepValues) => [
        getFieldRequiredValidationCheck(stepValues.organizationName, 'organizationName', `Please enter your organization's name.`),
        getMaxLengthValidationCheck(stepValues.organizationName, 'organizationName', ORGANIZATION_NAME_MAX_LENGTH),
        {
            name: 'valid ein',
            condition: (stepValues: MainOrganizationDetailsStepValues) => {
                return stepValues.isForProfit || einIsValid(stepValues.ein)
            },
            error: new ValidationError(`Please enter your organization's 9 digit EIN.`, ['ein'])
        },
        getFieldRequiredValidationCheck(stepValues.signUpCode, 'signUpCode', `Please enter the sign up code that was emailed to you.`),
    ];

export const OrganizationPrimaryDetailsValidation = (stepValues: MainOrganizationDetailsStepValues) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, stepValues)),
        valid: getValidationErrors(validationChecks, stepValues).length === 0
    }
}